import { objectSpread2 as _objectSpread2 } from './_virtual/_rollupPluginBabelHelpers.mjs';
import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { SizeWrapper, TouchWrapper } from './styles/styledComponents.mjs';
import { jsxs, jsx } from 'react/jsx-runtime';

var Svg36Userprofile = /*#__PURE__*/React.memo(function (props) {
  useContext(ThemeContext);
  props.iconColor;
  var component = /*#__PURE__*/jsxs("svg", _objectSpread2(_objectSpread2({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 36 36"
  }, props), {}, {
    children: [/*#__PURE__*/jsx("circle", {
      cx: 18,
      cy: 18,
      r: 18,
      fill: "#fff"
    }), /*#__PURE__*/jsx("circle", {
      cx: 18,
      cy: 18,
      r: 18,
      fill: props.iconColor ? props.iconColor : "#010505",
      fillOpacity: 0.36
    }), /*#__PURE__*/jsx("circle", {
      cx: 18,
      cy: 18,
      r: 17.5,
      stroke: props.iconColor ? props.iconColor : "#010505",
      strokeOpacity: 0.16
    }), /*#__PURE__*/jsx("path", {
      fill: "#fff",
      fillRule: "evenodd",
      d: "M22.643 24.446c-1.174-.95-1.217-2.715-.109-3.74a5.72 5.72 0 0 0 1.844-4.21v-3.214a5.743 5.743 0 0 0-5.743-5.743h-1.27a5.743 5.743 0 0 0-5.743 5.743v3.213c0 1.666.71 3.164 1.844 4.212 1.108 1.024 1.064 2.79-.108 3.739a4.7 4.7 0 0 1-1.354.764c-1.898.689-4.293 1.703-6.06 2.948a.4.4 0 0 0-.065.586A16.16 16.16 0 0 0 18 34.2c4.825 0 9.154-2.11 12.122-5.456a.4.4 0 0 0-.066-.585c-1.766-1.246-4.16-2.26-6.059-2.95a4.7 4.7 0 0 1-1.353-.763",
      clipRule: "evenodd"
    })]
  }));
  if (props.size) {
    component = /*#__PURE__*/React.createElement(SizeWrapper, {
      size: props.size
    }, component);
  }
  if (props.touch) {
    component = /*#__PURE__*/React.createElement(TouchWrapper, {
      size: props.size,
      touch: props.touch
    }, component);
  }
  return component;
});
var Svg36Userprofile$1 = Svg36Userprofile;

export { Svg36Userprofile$1 as default };
